<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="false"
      width="500px"
      class="releaseAppDialog"
    >
      <div class="a-d-top">
        <div class="a-d-topTit">
          <div>{{ lang.publish_app }}</div>
        </div>
        <div class="a-d-t-right">
          <span @click="close()">×</span>
        </div>
      </div>
      <div class="bfd_box" v-loading="loading" label-position="top">
        <el-form :model="form" :rules="rules" ref="ruleForm">

          <el-form-item
            :label="lang.app_url"
            style="display: flex;flex-direction: column;align-items: flex-start;"
          >
            <el-radio-group v-model="form.json.model">
              <el-radio label="1">{{ lang.session_model }}</el-radio>
              <el-radio label="2">{{ lang.File_generation }}</el-radio>
              <el-radio label="3">{{ lang.immersion }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            :label="lang.set_visibility"
            style="display: flex;flex-direction: column;align-items: flex-start;"
          >
            <el-radio-group v-model="form.juri">
              <el-radio label="3" v-show="showAll">{{ lang.publish_to_organization+`【${showAll==1?lang.authority:lang.winnow}】` }}</el-radio>
              <el-radio label="2">{{ lang.post_to_personal }}</el-radio>
              <el-radio label="1">{{ lang.post_to_everyone }}</el-radio>
            </el-radio-group>
          </el-form-item>


					<el-form-item label="权限设置"  style="display: flex;flex-direction: column;align-items: flex-start;">
						<el-radio-group v-model="form.json.copy" style="display: flex;flex-direction: column;">
              <el-radio label="0" class="radioItem">{{ lang.only_experience }}</el-radio>
              <el-radio label="1" class="radioItem">{{ lang.allow_other }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <div
            style="display: flex;width: 100%;justify-content: space-between;align-items: center;"
          >
            <el-form-item :label="lang.app_category" prop="type">
              <el-select
                v-model="form.type"
                :placeholder="lang.select_app_type"
                style="width: 300px;"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="bfd_bottom">
        <el-button @click="close()">{{ lang.cancel }}</el-button>
        <el-button type="primary" @click="submitBtn('ruleForm')"
          >{{ lang.confirm_publish }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
let validUrl = (rule, value, callback) => {
  if (value) {
    // 验证链接是否有效
    try {
      new URL(value);
      callback();
    } catch (error) {
      return callback(new Error(this.lang.input_app_url));
    }
  }
};
export default {
  props: {
    typeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
		userId: String,
		org: String,
		oid: String,
		region: {
			type: String,
			default: "cn",
		},
		juriListData:{
			type:Array,
			default:() => {
        return [];
      }
		}
  },
  data() {
    return {
      loading: false,
      show: false,
      form: {
        name: "",
        label: "",
        detail: "",
        url: "",
        type: "",
        juri: "1",
        stand: "cn",
        json: {
          icon: "",
          copy: "0"
        }
      },
      rules: {

        juri: [{ required: true, message: this.lang.select_permission, trigger: "blur" }],
        type: [{ required: true, message: this.lang.select_app_type, trigger: "blur" }],
        url: [
          { required: true, message: this.lang.input_app_url, trigger: "blur" },
          { validator: validUrl, trigger: "blur" }
        ]
      }
    };
  },
	computed:{
		showAll(){
			let _result = 0;
			if(this.juriListData.length>0){
				this.juriListData.forEach(i=>{
					let type = i.type;
					if(type=="oid"){
						type="organizeid"
					}else if(type=="userid"){
						type="userId"
					}

					if(i.jid==this.$store.state.user[type]){
						_result = i.utype
					}
				})
			}

			return _result;
		},
	},
  methods: {
    open(data) {
      if (!data.form.json) {
        data.form.json = { icon: "", copy: "0" };
      }
			if(!data.form.json.icon){
				data.form.json.icon = ""
			}
			if(!data.form.json.copy){
				data.form.json.copy = "0"
			}
      if(!data.form.json.model){
        data.form.json.model = "1"
      }

      if(!data.form.type){
        data.form.type = this.typeList[0].id?this.typeList[0].id:''
      }

      data.form.juri = '3'
      this.form = data.form;
      this.loading = false;
      this.show = true;
    },
    close() {
      this.show = false;
      this.init();
    },
    init() {
      this.form = {
        name: "",
        label: "",
        detail: "",
        url: "",
        type: "",
        juri: "1",
        stand: "cn",
        json: {
          icon: "",
          copy: "0"
        }
      };
      this.loading = false;
    },
    submitBtn(ref) {
      if (this.loading) return this.$message.info(this.lang.pleaseWait+"...");
      this.$refs[ref].validate(valid => {
        if (valid) {
          this.$emit("success", this.form);
        }
      });
    },
  }
};
</script>

<style scoped>
.releaseAppDialog >>> .el-dialog {
  min-width: 700px;

  height: 550px;
	/* height: 780px; */
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.releaseAppDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 550px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 10px;
}
.releaseAppDialog >>> .el-dialog__header {
  display: none !important;
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
  width: 320px;
  height: 32px;
}
.a-d-top >>> .el-input__icon {
  line-height: 32px;
}

.a-d-topTit {
  /* width: 171px; */
  /* margin-left: 20px; */
  height: 32px;
  display: flex;
  font-weight: bold;
  font-size: 20px;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}

.a-d-t-right > span {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.bfd_bottom {
  display: flex;
  justify-content: flex-end;
}

.bfd_icon {
  width: 70px;
  height: 70px;
  box-sizing: border-box;
  padding: 5px;
  margin-right: 40px;
  cursor: pointer;
}

.bfd_icon > svg {
  width: 100%;
  height: 100%;
}

.bfd_icon > span {
  width: 100%;
  height: 100%;

  display: block;
}

.bfd_icon > span >>> svg {
  width: 100%;
  height: 100%;
}

.switchForm{
	display: flex;
	align-items: center;
}

.switchForm>span{
	margin-left: 10px;
}

.radioItem{
	margin-bottom: 10px;
}
</style>
